import { render } from "./WordsByDifficulty.vue?vue&type=template&id=5af2ee1a"
import script from "./WordsByDifficulty.vue?vue&type=script&lang=js"
export * from "./WordsByDifficulty.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/gilcode.com/kwordz.gilcode.com/packages/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__